const promptUnit = {
  tableConfig: {
    showCheckbox: true
  },
  queryList: [
    // {
    //   name: 'type',
    //   label: '类型',
    //   notNull: false,
    //   component: 'select',
    //   componentAttr: {
    //     options: [
    //       {
    //         value: '1',
    //         label: '专家'
    //       },
    //       {
    //         value: '2',
    //         label: '接收单位'
    //       }
    //     ]
    //   }
    // },
    {
      name: 'year',
      label: '年份',
      notNull: true,
      component: 'select',
      request: {
        method: 'post',
        addr: '/school/schoolQuarter/getSchoolYearList',
        data: {},
        format: {
          value: 'auditYear',
          label: 'auditYear'
        }
      }
    },
    {
      name: 'quarter',
      label: '送审季度',
      notNull: true,
      component: 'select',
      componentAttr: {
        options: [
          {
            value: '第一季度',
            label: '第一季度'
          },
          {
            value: '第二季度',
            label: '第二季度'
          },
          {
            value: '第三季度',
            label: '第三季度'
          },
          {
            value: '第四季度',
            label: '第四季度'
          }
        ]
      }
    },
    {
      name: 'name',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'paperUnitName',
      label: '送审单位',
      component: 'input'
    }
  ],
  urlMap: {
    select: {
      url: '/custom/sendPaper/getUrgingUnitList'
    },
    urgeExpert: '/exp/expReviewInfo/warnMsgToExp',
    urgeUnit: '/exp/expReviewInfo/warnMsgToOffice'
  },
  operList: [// 操作列表
    {
      name: 'sendUrgeUnit',
      label: '发送单位催评短信',
      show: true,
      action: {
        type: 'request',
        method: 'post',
        data: '("{tableSelectionIds}").split(",")',
        addr: 'urgeUnit'
      }
    }
    // ,
    // {
    //   name: 'sendUrgeUnit',
    //   label: '发送单位催评短信',
    //   show: true,
    //   action: {
    //     type: 'request',
    //     method: 'post',
    //     data: '("{tableSelectionIds}").split(",")',
    //     addr: '/exp/expReviewInfo/warnMsgToOffice'
    //   }
    // }
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'unitSchoolName',
      label: '接收单位'
    },
    {
      name: 'batchName',
      label: '批次名'
    },
    {
      name: 'paperUnitName',
      label: '送审单位'
    },
    {
      name: 'name',
      label: '姓名'
    },
    {
      name: 'receiveStr',
      label: '指派情况'
    },
    {
      name: 'reviewNum',
      label: '提交情况'
    },
    {
      name: 'urgingNum',
      label: '催评记录',
      width: 150
    },
    {
      name: 'urgingTime',
      label: '催评时间'
    }
  ]
}
export default promptUnit



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/customerThesis/promptUnit.js